import React from "react";
import PageHeader from "../../PageHeader";
import EditSlotForm from "./EditSlotForm";
import { ReactComponent as SlotIcon } from "../../../images/slotimage/slotimage.svg";
import { ReactComponent as BackIcon } from "../../../images/pageheadingicon/backicon.svg";
import useStyles from "../../../../styles";

function EditSlot() {
  const classes = useStyles();
  const Heading = [
    {
      id: 1,
      pageicon: <SlotIcon />,
      mainheading: "Edit Slot",
      // subhead: "Want to Add in Bulk ? ?",
      // downloadlink: "Download bulk Sample Files",
      addbtntext: "Back",
      addbtnicon: <BackIcon />,
      addbtnstyle: "transparentbtn",
      path: "/admin/slot",
    },
  ];
  return (
    <div className={`${classes.p2} ${classes.pb0}`}>
      <PageHeader Heading={Heading} />
      <EditSlotForm />
    </div>
  );
}
export default EditSlot;
